import { formatErrorResponse } from '@quickbit/backoffice-core-frontend';
import { Modal, Snackbar, UtilityButton } from '@quickbit/qb-design-system';
import { useState } from 'react';
import { useAsyncFn } from 'react-use';
import { updateUser } from '../../../api';
import { VerificationStatus } from '../../../types';

export const RequestProofOfFunds = ({
  userReference,
  requested,
  onUpdated,
}: {
  userReference: string;
  requested: boolean;
  onUpdated: () => Promise<unknown>;
}) => {
  const [confirm, setConfirm] = useState(false);
  const [{ loading, error }, request] = useAsyncFn(async () => {
    await updateUser({
      userReference,
      sourceOfFundsVerificationStatus: VerificationStatus.REQUESTED,
    });
    setConfirm(false);
    await onUpdated();
  }, [userReference, onUpdated]);
  return (
    <>
      <UtilityButton
        text={requested ? 'Proof of funds requested' : 'Request proof of funds'}
        disabled={requested || loading || !userReference}
        onClick={() => setConfirm(true)}
      />
      {confirm && (
        <Modal
          title="Request proof of funds?"
          closeModal={() => !loading && setConfirm(false)}
          primaryButtonProps={{
            text: 'Request proof of funds',
            loading,
            onClick: () => void request(),
          }}
          secondaryButtonProps={{
            text: 'Cancel',
            disabled: loading,
            onClick: () => setConfirm(false),
          }}
        >
          <p>
            This sets the customer&apos;s source-of-funds verification to
            Requested and requires them to provide it through the existing App
            verification flow.
          </p>
        </Modal>
      )}
      <Snackbar
        open={!!error}
        variant="danger"
        message={error ? formatErrorResponse(error) : ''}
      />
    </>
  );
};
